import React, { useEffect, useState } from "react"
import "../styles/Shop.css"
import create from "../images/create.png"
import { Link,useLocation, NavLink, Outlet, Route, Routes } from "react-router-dom"
import EachShop from "./EachShop"
import { IconButton, Tooltip, useMediaQuery } from "@mui/material"
import axios from "axios"
import AddIcon from '@mui/icons-material/Add';


export default function Shop({propsData}){


    const location = useLocation();
   // console.log(location.pathname);

   let [error,setError]=useState()
   let [allShops,setAllShops]=useState()
   const [routes, setRoutes] = useState(location.pathname.split('/'));
   const [active, setActive] = useState(null);
  // console.log(routes[3]==="create");

    
   useEffect(()=>{

        axios.get(`${process.env.REACT_APP_URL}/api/shope/getUserShopes`, {
          headers: {
            Authorization: `Bearer ${propsData.userData?.token}`,
            'Content-Type': 'application/json'
          },
        })
        .then((response) => {
          console.log(response.data);
          setAllShops(response.data)
        })

        .catch((error) => {
         // console.error(error);
          if (error.response) {
            setError(error.response.data.error||"Error occured please try again !!!");
          } else {
            setError('An error occurred. Please try again.');
          }
          setTimeout(() => {
            setError('');
          }, 10000);
        });
    },[propsData.equilizer])

    useEffect(() => {
      let currntRoute=location.pathname.split('/')
          setActive(currntRoute[3]);
  }, [location, routes]);

  const matches = useMediaQuery('(max-width:800px)');


    return (
        <div className={active === "create" ?  "create-shop-container" :"shop-container"}>
            <div  className={active === "create" ? "shope-body-all-createRoute" : "shope-body-all"}>
              <NavLink className="shop-create-shop" to="create">
                 <div  className={(active === "create"&&!matches) ? "shope-body-all-createRoute-create" : "shope-body-all-create"}>
                        <div ><IconButton style={{background:active === "create"&&"#866206",color:"white"}}><AddIcon/></IconButton></div>
                        
                 </div>
              </NavLink>

                {/* <div className="shope-body-all-allShopes"> */}
                    {
                        allShops?.map(item => {

                            return( 
                                <>
                                <Link key={item._id} className={active === "create" ? `create-shop-shop-account` :  `shop-each-shopeAccount`} to={`/shop/${item._id}`}>
                                    <img  src={item?.coverPic?.fileUrl||"/default_shope_pic.png"} className={active == "create" ? "create-shop-profile-picture" : "shop-each-shopeAccount-profile-picture"} />
                                    <div className={active === "create" ? "create-shop-shop-name" : "shop-each-shopeAccount-name"}>{item.shope_name}</div>
                                </Link>
                                </>
                            )
                        })
                    }
                {/* </div> */}

            </div>
            <div  className="shop-createRoute"> <Outlet/></div>
          
        </div>
    )
}
